import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../auth/AuthContext';

const API_BASE = import.meta.env.VITE_API_URL || `http://${window.location.hostname}:7070`;

const PLAN_FEATURES = {
  SOLO:        { maxShops: 1,  maxStaff: 2,  analyticsMaxDays: 7,  heatmap: false, staffTable: false, csvExport: false, dynamicQr: false },
  HIGH_STREET: { maxShops: 3,  maxStaff: 10, analyticsMaxDays: 30, heatmap: true,  staffTable: true,  csvExport: false, dynamicQr: true  },
  CHAIN:       { maxShops: 10, maxStaff: -1, analyticsMaxDays: 90, heatmap: true,  staffTable: true,  csvExport: true,  dynamicQr: true  },
  INTERNAL:    { maxShops: -1, maxStaff: -1, analyticsMaxDays: 366,heatmap: true,  staffTable: true,  csvExport: true,  dynamicQr: true  },
};

export default function usePlan() {
  const { user, token } = useAuth();
  const plan = user?.plan || 'SOLO';
  const features = PLAN_FEATURES[plan] || PLAN_FEATURES.SOLO;

  const [usage, setUsage] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchUsage = useCallback(() => {
    if (!token) return;
    setLoading(true);
    fetch(`${API_BASE}/api/v1/plan`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.ok ? r.json() : null)
      .then(data => { if (data) setUsage(data.usage); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [token]);

  useEffect(() => { fetchUsage(); }, [fetchUsage]);

  return {
    plan,
    features,
    usage,
    loading,
    refetchUsage: fetchUsage,
    canViewHeatmap: features.heatmap,
    canViewStaffTable: features.staffTable,
    canExportCsv: features.csvExport,
    canUseDynamicQr: features.dynamicQr,
    maxAnalyticsDays: features.analyticsMaxDays,
    canCreateShop: usage ? (features.maxShops < 0 || usage.currentShops < features.maxShops) : true,
    canInviteStaff: usage ? (features.maxStaff < 0 || usage.currentStaff < features.maxStaff) : true,
  };
}
